export const applicationAccessConstant = {
    incidentRequestRaiseTicketUrl:
        'https://roche.service-now.com/rose?id=sc_cat_item&sys_id=ea43c208874bda5030ea87340cbb3584&application_name=ecb',
    noAccessMessageSdt:
        "It appears that you don't have access to the <strong>Study Design Suite</strong> application. Please request the access via RoSE portal.",
    sdtAdminGoupAccessName: ['DOP_SDT_Admin_', 'GLODOP_SDS_Admin_'],
    sdtGoupAccessName: ['DOP_SDT_', 'GLODOP_SDS_'],
    sdtrequestAccessLink:
        'https://roche.service-now.com/rose?id=sc_cat_item&sys_id=a22f167087521650912332640cbb35ee',
};

export const defaultProjectTableSort = {
    ascending: false,
    filterName: 'last_updated_on',
};

export const FOOTER = {
    dateLastRefreshedText: 'Date last refreshed: ',
    link: 'https://roche.service-now.com/rose?id=sc_cat_item&sys_id=ea43c208874bda5030ea87340cbb3584&application_name=ecb',
    linkText: 'here',
    serviceNowText:
        'If you have any questions and/or feedback, please raise issue',
    termsConditionText: 'Information on terms and conditions can be found',
};

export const NO_ACCESS_DIALOG = {
    accessHyperLink: FOOTER.link,
    accessLinkText: 'Request Access',
    dialogContentText:
        ' Your account does not have access to DOP suite. Please request the access via RoSE portal.',
    dialogHeaderText: 'Request access',
};

export const projectConstant = {
    projectDeletionSubTitle: 'Project once deleted cannot be reverted back',
    projectDeletionTitle: 'Are you sure you want to delete this project?',
};

export const selectClinicalStudiesConstant = {
    bannerMessage:
        'If the section contains a combination of text , tables or images, only textual data will be extracted.',
    noFileUploaded: 'No files have been uploaded yet.',
    noSectionBannerMessage:
        'Some sections were unable to be located and may be missing',
    requiredErrorMsg:
        'One or more Inclusion/Exclusion Criteria information are missing',
    resetEligibilityCriteria:
        'Are you sure you want to overwrite existing Study Eligibility Criteria content?',
    resetStudies: 'All your changes will be lost. Do you want to confirm?',
    studyCriteriaRequired: 'Please add information to proceed.',
    studyCrtieriaRequiredAction: 'Please provide the study information',
    studyPrexists:
        'Same content is repeated in one or more Inclusion/Exclusion criteria',
    studyPrexistsAction: '',
    uploadFile: 'Upload a new file in AI PDF Deconstructor',
    userIsViewer: 'Next step is not yet started/completed',
};

export const instructionstoGenAIConstant = {
    additionalInstructionsText:
        'The changes you make here may result in unexpected results. You can always return to this step and reset the instructions to the default.',
    instructionDeletionSubTitle:
        'Instruction once deleted cannot be reverted back',
    instructionDeletionTitle:
        'Are you sure you want to delete this instruction?',
    resetInstructions: 'Do you want to override the instructions?',
    selectInstruction: 'Select Instruction',
    useSelectedInstruction: 'Do you want to use selected instruction?',
};

export const notificationConstant = {
    deprecatedModelDraftBannerMessage:
        'Note, this Draft Recommendation was created using older version of GenAI model that is no longer supported. You can view it in a read only mode.',
    deprecatedModelHeatmapBannerMessage:
        'Note, this Insights for Adjudication (heatmap) was created using older version of GenAI model that is no longer supported. You can view it in a read only mode.',
    errorResponse: 'Failed to fetch data. Please try again later.',
    resetHeatmapConfirmationMessage:
        'Are you sure you want to restore the Original Adjudication. Changes once reverted cannot be reverted back.',
    resetHeatmapConfirmationTitle: 'Restore Original Adjudication',
    lockedProjectBannerMessage:
        'The <strong>{scenario_name}</strong> - <strong>{element_name}</strong> you are currently viewing has been locked. No further changes are allowed, and the content is now available in view-only mode.',
    retiredProjectBannerMessage:
        'The <strong>{scenario_name}</strong> - <strong>{element_name}</strong> you are currently viewing has been retired. No further changes are allowed, and the content is now available in view-only mode.',
    serverError: 'Internal error, please contact the admin',
    unsavedChanges:
        'There are some unsaved changes. Do you want to save them now?',
    unsavedSelections:
        'There are some unsaved selections. Do you want to save them now?',
};

export const globalConstant = {
    ZERO: 0,
    emailLink: 'protocol.digitalization@roche.com',
    exclusionLabel: 'Exclusion',
    featureType: 'Inclusion+Exclusion',
    filterName: 'last_updated_on',
    heatmapNotMentionedValue: 'Not mentioned',
    inclusion_label: 'Inclusion',
    maxFilterValueDisplayedOn: 100,
    noAPDAccessMessage: "You don't have access to AI PDF Deconstructor",
    noSILAccessMessage: "You don't have access to Study Information Library",
    prexistsTooltip: 'already exists',
    priorityTooltip:
        "Prioritizing a study as 'Benchmark' establishes its Eligibility Criteria as the baseline against which other studies will be evaluated.",
    priorityTwoToolTip:
        'designates its Eligibility Criteria for comparison with the baseline set by the Benchmark study.',
    requiredTooltip: 'is required!',
    select: '- Select -',
    studyDesignSuiteLabel: 'Study Design Suite',
};

export const heatmapConstant = {
    uncategorizedContent: 'Uncategorized content',
};

export const statusCode = {
    badRequest: 400,
    debounceTimer: 300,
    internalServerError: 500,
    ok: 200,
    unAuthorized: 401,
};

export const routes = {
    entryURL: '/entry',
    loginURL: '/login',
    projectDetailURL: '/app/project/project-details',
    projectURL: 'app/project',
    workbenchURL: '/app/ecb-workbench',
};

export const loaderConstant: any = {
    adjudicationErrorResponse:
        'Heatmap is taking too long to generate. Please try again later. If the problem persists, contact the administrator.',
    defaultLoaderDuration: 0.25,
    defaultLoaderText: 'Please wait...',
    draftErrorResponse:
        'Draft generation is taking too long to generate. Please try again later. If the problem persists, contact the administrator.',
    fetchingInstructionsLoaderText: 'Fetching Library of Instructions',
    fetchingProjectLoaderText: 'Fetching Projects',
    generateDraftLoaderDuration: 5,
    generateDraftLoaderText:
        'Transforming your chosen criteria into a cohesive narrative.',
    generateDraftSubLoaderText: 'Your draft is on its way..',
    generateHeatmapLoaderDuration: {
        'Inclusion+Exclusion': {
            1: 3,
            2: 5,
            3: 6,
            4: 9,
        },
        Other: {
            1: 2,
            2: 4,
            3: 5,
            4: 7,
        },
    },
    generateHeatmapLoaderText: `GenAI is working hard crafting out the intricacies of Inclusion and Exclusion criteria. Your visual guide is almost complete...`,
    generateHeatmapSubLoaderText: ' Grab a coffee while we finish up...',
    intervalTime: 3000,
    saveDraftLoaderDuration: 0.75,
};

export const draftRecommendationConstant = {
    deleteCriteriaTitle: 'Are you sure you want to delete this criterion?',
    deleteCrtieriaSubTitle: 'Criterion once deleted cannot be reverted back',
    iRValidationErrorMessageAll: `To proceed further, please add all Rationales and
            accept/reject Inclusive Research Recommendations for both Inclusion and Exclusion Criteria.`,
    iRValidationErrorMessageExclusionAll: `To proceed further, please add all Rationales and
            accept/reject Inclusive Research Recommendations for Exclusion Criteria.`,
    iRValidationErrorMessageInclusionAll: `To proceed further, please add all Rationales and
            accept/reject Inclusive Research Recommendations for Inclusion Criteria.`,
    iRValidationErrorMessageNoCriteria: `Add at least one criterion to proceed.`,
    iRValidationErrorMessageRationale: `To proceed further, please add all Rationales for both
            Inclusion and Exclusion Criteria.`,
    iRValidationErrorMessageRationaleExclusion: `To proceed further, please add all Rationales for
            Exclusion Criteria.`,
    iRValidationErrorMessageRationaleInclusion: `To proceed further, please add all Rationales for
            Inclusion Criteria.`,
    iRValidationErrorMessageRecommendation: `To proceed further, please accept/reject Inclusive Research
            Recommendations for both Inclusion and Exclusion Criteria.`,
    iRValidationErrorMessageRecommendationExclusion: `To proceed further, please accept/reject Inclusive
            Research Recommendations for Exclusion Criteria.`,
    iRValidationErrorMessageRecommendationInclusion: `To proceed further, please accept/reject Inclusive
            Research Recommendations for Inclusion Criteria.`,
    recommendationTextLabel:
        'Please select your decision and, if applicable, provide a reason to support it. This helps ensure clarity, transparency, and traceability in the review process.',
};

export const auditTrailContant = {
    tabConfig: {
        ec_draft_criteria_rationale: 'Criteria Rationale',
        ec_recommendation: 'Inclusive Research Recommendation',
    },
};

export const createNewProjectsConst = {
    commenterLabelText: 'Commenter (Enter at least 3 characters to search)',
    createHeaderText: 'Create New Protocol',
    editorLabelText: 'Editor (Enter at least 3 characters to search)',
    noMatchingUserFound: 'No matching user(s) found.',
    projectInfoText: 'Project information',
    protocolTitleText: 'Project Title',
    shareProjectTitleText: 'Share Project',
    studyPhasePlaceholderText: '- Select Study Phase -',
    studyPhaseTitleText: 'Study Phase',
    therapeuticAreaPlaceholderText: '- Select Therapeutic Area -',
    therapeuticAreaTitleText: 'Therapeutic Area',
    updateHeaderText: 'Update Protocol',
    userAlreadyFoundInAnotherGroup: 'User already part of another group',
    viewerLabelText: 'Viewer (Enter at least 3 characters to search)',
};
export const tableDashboardConstant = {
    noUserAccess: "You don't have access",
};

export const genericErrorMessage: GenericErrorModel = {
    commenterRole: 'commenter',
    editorRole: 'editor',
    noAccessButtonAndIconMessage:
        "You don't have access to perform this action.",
    noAccessFieldMessage: "You don't have access to edit.",
    noAccessLabel: 'You have read-only access',
    userIsViewer: 'Next step is not yet started/completed',
    viewerRole: 'viewer',
};

export interface GenericErrorModel {
    commenterRole: string;
    editorRole: string;
    noAccessButtonAndIconMessage: string;
    noAccessFieldMessage: string;
    noAccessLabel: string;
    userIsViewer: string;
    viewerRole: string;
}

export const editDrawerTabs = {
    tabConfig: {
        comments: 'Collaboration Comments',
        notes: 'Clarification',
    },
};

export const criteriaTipsContent: Record<string, Record<string, string>> = {
    gred: {
        inclusion:
            'https://drive.google.com/file/d/16c_l8eICkpe_J0rUFbJRxVxyOVdczp3k/view?usp=drive_link',
        exclusion:
            'https://drive.google.com/file/d/1x44-jIImmOBPFVdMCvwyi88-leRCwlV8/view?usp=drive_link',
    },
    pd: {
        inclusion:
            'https://drive.google.com/file/d/1LYNgiRJCNhvntobCKSFJwEpSWMtOIa57/view?usp=drive_link',
        exclusion:
            'https://drive.google.com/file/d/1BfxJI5U-NYG8WHjQOLrSY3y2-OHFbg8s/view?usp=drive_link',
    },
    pred: {
        inclusion:
            'https://drive.google.com/file/d/12OvBoAbAzDCbaE6vbkWoYc7zUGXo5LWR/view?usp=drive_link',
        exclusion:
            'https://drive.google.com/file/d/1z_3c4QrzoF2Sk5dKvbLElJCtyukA44sV/view?usp=drive_link',
    },
    default: {
        inclusion:
            'https://drive.google.com/file/d/1Lh1q4CmRcSojaETX6KZlUxf3ZHez4uoB/view?usp=drive_link',
        exclusion:
            'https://drive.google.com/file/d/1s8iNyugvud-3xyyDME1aWxvUKZGkPBgL/view?usp=drive_link',
    },
};

// TODO: replace with accountable-party specific links once available
const soaDefaultInstructionsLink =
    'https://docs.google.com/spreadsheets/d/1Qdssg3cA5_EbFXEzjklKCm7UqL66abLX/edit?gid=1883065390#gid=1883065390';

export const soaInstructionsContent: Record<string, string> = {
    gred: soaDefaultInstructionsLink,
    pd: soaDefaultInstructionsLink,
    pred: soaDefaultInstructionsLink,
    default: soaDefaultInstructionsLink,
};

export const soaMessageConstant = {
    resetSoaConfirmationMessage:
        'Reset SoA table to its initial state. All comments on the table will be deleted too. This action cannot be undone.',
    resetSoaConfirmationTitle: 'Reset SoA Table',
    attributeUpdateSuccessMessage: 'Activity attribute updated',
};
